"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.client = exports.update = exports.get = exports.setConfig = void 0;

var _instance = require("../shared/aws/instance");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Default = {
  Table: "Settings",
  hKey: "uid",
  rKey: "name"
};

var setConfig = function setConfig() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  Default = _objectSpread({}, Default, options);
};

exports.setConfig = setConfig;

var get = function get(uid, name) {
  var _Key;

  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var params = {
    TableName: options.table || Default.Table,
    Key: (_Key = {}, _defineProperty(_Key, options.hKey || Default.hKey, uid), _defineProperty(_Key, options.rKey || Default.rKey, name), _Key)
  };
  return _instance.documentClient.get(params).promise();
};

exports.get = get;

var update = function update(_ref, options) {
  var _Key2;

  var table = _ref.table,
      uid = _ref.uid,
      name = _ref.name,
      value = _ref.value;
  var params = {
    TableName: table || Default.Table,
    Key: (_Key2 = {}, _defineProperty(_Key2, options.hKey || Default.hKey, uid), _defineProperty(_Key2, options.rKey || Default.rKey, name), _Key2),
    UpdateExpression: "set #value = :value",
    ExpressionAttributeNames: {
      "#value": "value"
    },
    ExpressionAttributeValues: {
      ":value": emptyChecker(value)
    }
  };
  return _instance.documentClient.update(params).promise();
};

exports.update = update;
var client = _instance.documentClient; //USAGE
// dynamoUpdate({
//     table: "Settings",
//     uid: "3180",
//     name: "email",
//     value: "...",
//   });

exports.client = client;

function emptyChecker(text) {
  var tmpText = _lodash.default.cloneDeep(text);

  if (tmpText === "") {
    tmpText = null;
  }

  return tmpText;
}